import { configureApi, createQueryClient, type CreateQueryClientOptions } from '@pa/api'
import type { AuthStore, StaffSession } from '@pa/staff'
import type { QueryClient } from '@tanstack/react-query'
import type { StaffEnv } from './env'

export const DEFAULT_TIMEOUT_MS = 10_000

/**
 * `configureApi()` for a staff app (Frontend §3.2): header auth with the Firebase ID token, no cookies, a 401 after
 * one refresh → A-06, and the access errors → the guards.
 */
export function setupApi(env: StaffEnv, auth: AuthStore, session: StaffSession): void {
  configureApi({
    baseUrl: env.VITE_API_ORIGIN,
    credentials: 'omit',
    defaultTimeoutMs: DEFAULT_TIMEOUT_MS,
    validateResponses: env.VITE_ENV !== 'prod',
    getIdToken: (forceRefresh) => auth.getIdToken(forceRefresh),
    onAuthFailure: (e) => {
      session.onAuthFailure(e)
    },
    onAccessError: (e) => {
      session.onAccessError(e)
    },
  })
}

export const createStaffQueryClient = (options?: CreateQueryClientOptions): QueryClient =>
  createQueryClient('staff', options)
